import type { SavingsConfig } from '../ProductsConfig';
import { termDepositOverviewConfig } from './term-deposit-overview-config/base';
import { settingsDetails } from './settings-details-config/base';
import { savingEnvelopes } from './saving-envelopes-config/base';

export const savings: SavingsConfig = {
    basic: true,
    showAccountFeatures: false,
    showDisposableTogetherWithBalanceAndTargetAmountInOverviewCard: false,
    useDisposableInsteadOfBalance: false,
    useDisposableAndBalanceInOverviewCard: false,
    allowedPurposeSavingsFlags: [] as string[],
    overview: {
        termDeposit: termDepositOverviewConfig,
        enabled: true,
    },
    associatedCards: {
        enabled: true,
    },
    statements: {
        createStatement: true,
        deliveryDefinitions: {
            distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
            format: ['PDF_A4'],
            periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
            canCreateDefinition: true,
            channelEditable: false,
            statementNumberEditable: true,
        },
        showHelpCenterInfoBox: false,
        showMultiDownloadCard: false,
        showNewCustomStatementCard: false,
        showDownloadOptions: false,
    },
    cancellation: {
        enabled: false,
        immediatelyRedirectToOverviewAfterClosing: false,
        options: {
            showComplexTargetAccountSelect: false,
            showCancellationTypeSelect: false,
        },
        signing: {
            showCancellationTitle: false,
            showCancelledAccountInfo: false,
            showTargetAccountInfo: false,
        },
        error: {
            showBlockedInvestigation: false,
            showBlockedFraud: false,
            blockedInvestigationKey: '',
            blockedFraudKey: '',
        },
        focusPage: {
            errorPageTitle: '',
            successPageTitle: '',
            signingPageTitle: '',
            optionsPageTitle: '',
        },
        successMessage: '',
    },
    /** Configs for savings settings page */
    settingsDetails,
    savingEnvelopes,
    newTransfer: {
        sideMenuLabel: '',
    },
    layout: {
        productInfo: {
            showProductIdentifier: false,
            showDisposableAndBalanceAmounts: false,
            showBalanceAndDisposableAmounts: false,
        },
    },
};
